import React from 'react'
import { AppBar, Toolbar, Tooltip, IconButton, useScrollTrigger, makeStyles } from '@material-ui/core'
import ExitIcon from '@material-ui/icons/ExitToApp'

import { AppRoute } from '../Routes'
import { isDebug } from '../App.config'
import { concedeControl as LMSConcede, isAvailable } from '../LMS'
import { User } from '../interfaces/Types'

import Breadcrumbs from './Breadcrumbs'
import { drawerWidth } from './Main'

type TopBarProps = {
    LMSAvailable: boolean
    user: User
    crumbs: AppRoute[]
}

const TopBar = (props: TopBarProps) => {
    const classes = useStyles()
    return (
        <ElevationScroll {...props}>
            <AppBar position={'fixed'} className={classes.appBar}>
                <Toolbar>
                    <div className={classes.crumbs}>
                        <Breadcrumbs crumbs={props.crumbs} />
                    </div>
                    <Tooltip title={props.user.companyName}>
                        <span className={classes.user}>{props.user.userName.replace(/,/g, ', ')}</span>
                    </Tooltip>
                    <ExitButton lmsIsAvailable={props.LMSAvailable} />
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    )
}

export default TopBar

// Exit Button

type ExitButtonProps = {
    lmsIsAvailable: boolean
}

const handleExit = (e: React.MouseEvent) => {
    e.preventDefault()
    isAvailable() && LMSConcede()
    !isAvailable() && isDebug && console.log('You are in debug mode without an LMS. So clicking Exit does nothing. :)')
}
const ExitButton: React.FC<ExitButtonProps> = ({ lmsIsAvailable }: ExitButtonProps) => {
    if (!lmsIsAvailable) return <></>
    return (
        <Tooltip title={'Exit Reporting Module to LMS.'}>
            <IconButton onClick={handleExit} color={'primary'}>
                <ExitIcon />
            </IconButton>
        </Tooltip>
    )
}

type ESProps = {
    children: React.ReactElement
}

const ElevationScroll = (props: ESProps) => {
    const { children } = props

    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0
    })

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    })
}

const useStyles = makeStyles(theme => ({
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
    },
    crumbs: {
        flexGrow: 1,
    },
    user: {
        padding: theme.spacing(0, 2)
    },
}))